<template>
  <section
    class="SubMenu tw-bg-gradient2-lr tw-py-6"
  >
    <div class="ns-container">
      <h1 class="heading-white tw-text-center">
        {{ title }}
      </h1>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
